import { Link } from "react-router-dom";

// Warning banner shown at the top of every legacy ops page (escrow bucket
// sweep, escrow treasury withdraw, escrow buckets, legacy affiliate bucket
// payouts). These pages are the OLD on-chain escrow path; normal partner
// payouts now go through the Treasury Ledger CRM (Partner Payables). The
// banner steers operators away without removing the page. Presentational
// only — no funds, no network.

export function LegacyOpsBanner({ what }: { what?: string }) {
  return (
    <div
      data-legacy-banner
      style={{
        margin: "0 0 14px 0",
        padding: "10px 14px",
        border: "1px solid var(--warn, #b58900)",
        background: "rgba(181, 137, 0, 0.08)",
        borderRadius: 6,
        fontSize: 12.5,
        lineHeight: 1.5,
        color: "var(--fg)",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 8,
      }}
    >
      <span
        style={{
          fontSize: 10,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          color: "var(--warn, #b58900)",
          border: "1px solid var(--warn, #b58900)",
          borderRadius: 999,
          padding: "1px 8px",
        }}
      >
        Legacy
      </span>
      <span>
        <strong>Legacy ops page. Use Treasury Ledger CRM for normal payouts.</strong>
        {what ? ` ${what}` : ""}
      </span>
      <Link
        to="/admin/partner-payables"
        style={{
          marginLeft: "auto",
          fontSize: 12.5,
          fontWeight: 600,
          color: "var(--accent, #2c7be5)",
          textDecoration: "none",
        }}
      >
        Open Partner Payables →
      </Link>
    </div>
  );
}
